import PropTypes from 'prop-types';
import React from 'react';
/**
 * A text summary of the current pagination state
 */

var Summary = function Summary(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      from = _ref.from,
      size = _ref.size,
      to = _ref.to,
      totalItems = _ref.totalItems;
  var start = Math.min(totalItems, from);
  var end = Math.min(totalItems, to);
  var fontSize = size === 'lg' ? 'larger' : size === 'sm' ? 'smaller' : undefined;
  return /*#__PURE__*/React.createElement("p", {
    className: className,
    style: {
      fontSize: fontSize
    }
  }, "Displaying: ", start, "-", end, " of ", totalItems);
};

Summary.displayName = "Summary";
Summary.propTypes = {
  className: PropTypes.string,
  from: PropTypes.number.isRequired,
  size: PropTypes.oneOf(['sm', 'lg']),
  to: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired
};
Summary.displayName = 'Summary';
export default Summary;